
import { useGetInstallationProductDetailQuery } from 'generated/graphql';

import React from 'react';

export interface IGqlObject {
  id: string;
  name: string;
  supplier: string;
  manufacturer: string;
  model: string;
  hardware: string;
  finish: string;
  notes: string;
}



export interface IData extends Record<string, string> {}

export function useQuery(installationId: string) {
  const tuple = useGetInstallationProductDetailQuery({
    variables: {
      id: installationId
    },
    skip: installationId === ''
  });

  return React.useMemo(
    () => {
      const productDetails = tuple.data?.installation?.product;
      const data: IGqlObject & IData = {
        id: productDetails?.id ?? '',
        name: productDetails?.name ?? '',
        supplier: productDetails?.supplier ?? '',
        manufacturer: productDetails?.manufacturer ?? '',
        model: productDetails?.model ?? '',
        hardware: productDetails?.hardware ?? '',
        finish: productDetails?.finish ?? '',
        notes: productDetails?.notes ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}

